import { render, staticRenderFns } from "./BadgesCard.vue?vue&type=template&id=2d12df9b&"
import script from "./BadgesCard.vue?vue&type=script&lang=js&"
export * from "./BadgesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports